export default __webpack_public_path__ + "static/media/Samyak_Mehta_Resume.0fe05202.pdf";